import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { SessionAlreadyCompletedContainer } = await import('@containers/Payment/ErrorScreens/SessionAlreadyCompleted');
    return {
        Component: SessionAlreadyCompletedContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
